


$(document).ready(() => {
  var acc = document.getElementsByClassName("accordion");
  var addToCartButton = document.getElementById('product-form');
 
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight !== "300px") {
        panel.style.maxHeight = "300px";
      } else {
        panel.style.maxHeight = "0px";
      }
    });
  }
  if (acc.length > 0){
    $('#product-form').insertBefore($('.accordion').first());
  }

  
});